import { NotificationTypeId } from "./notificationType";
import { ApplicationId } from "./applications";
import { Software, getSoftwareProductNumber } from "./software";
import { ValueOf } from "../../../utils/utils";
import { getErrorSourceForErrorNumber } from "./errorSources";
import { ProductTechnologyType } from "./productTechnology";
import { SalutationId } from "./salutation";

interface CreateRequestDataOptions {
    form: HTMLFormElement;
    callId: string;
    softwares: Software[];
    selectedMachineTechnology: ProductTechnologyType;
}
export const createRequestData = ({ form, callId, softwares, selectedMachineTechnology }: CreateRequestDataOptions) => {
    const formData: CreateCaseRequest = {
        callId,
        createdWith: "ServiceApp", // TODO: should this value be dynamic? - the BE only accepts predefined values at the moment.
        notificationType: Number(form["notificationType"].value),
        description: form["description"].value,
        callBackContact: {
            salutation: Number(form["salutation"].value),
            firstName: form["firstName"].value,
            lastName: form["lastName"].value,
            phone: form["phone"].value,
            email: form["email"].value
        },
        equipmentNo: form["productNo"]?.value,
        hmiErrorsWithInfo: Array.from(form.querySelectorAll("service-calls-dynamic-input input")).map((el: HTMLInputElement) => ({
            errorNumber: el.value,
            errorSource: getErrorSourceForErrorNumber(el.value, selectedMachineTechnology)
        })),
        software: {
            productNumber: getSoftwareProductNumber(softwares, form["softwareType"]?.value, form["softwareModule"]?.value),
            softwareModule: form["softwareModule"]?.value,
            softwareType: form["softwareType"]?.value,
            isInstallationProblem: form["installationProblem"]?.checked,
            isLicenseIssue: form["licenseIssue"]?.checked,
            softwareProblemClassification: form["softwareProblemClassification"]?.value
        },
        applicationTopicOptions: getApplicationOptions(form),
        purchaseOrderNumber: null, // there is no field in the form
        additionalText: null // there is no field in the form
    };
    return formData;
};

const getApplicationOptions = (form: HTMLFormElement) => {
    const applicationOptions: ApplicationId[] = [];
    if (form["application"]?.value) {
        applicationOptions.push(form["application"].value);
    }
    if (form["optics"]?.value) {
        applicationOptions.push(form["optics"].value);
    }
    if (form["applicationIssue"]?.value) {
        applicationOptions.push(form["applicationIssue"].value);
    }
    return applicationOptions;
};

export interface CreateCaseRequest {
    callId: string; // GUID
    createdWith: string; // this string is validated in the backend
    notificationType: NotificationTypeId;
    description: string;
    callBackContact: CallBackContact;
    equipmentNo?: string;
    hmiErrorsWithInfo?: HmiError[];
    software?: SoftwareInfo;
    applicationTopicOptions?: ApplicationId[];
    purchaseOrderNumber?: string | null;
    additionalText?: string | null;
}

export interface CallBackContact {
    salutation: SalutationId;
    firstName: string;
    lastName: string;
    phone: string;
    email: string;
}

export interface HmiError {
    errorNumber: string;
    errorSource: string;
}

export interface SoftwareInfo {
    productNumber: string;
    softwareModule: string;
    softwareType: string;
    isInstallationProblem: boolean;
    isLicenseIssue: boolean;
    softwareProblemClassification: string;
}

export const TRANSACTION_STATES = {
    RECEIVED: "Received" // other states tbd
};

interface CreateCaseResponseItem {
    callId: string;
    sisCaseId: string;
    transactionState: ValueOf<typeof TRANSACTION_STATES>;
    isOutsideOfServiceHours: 1 | 0;
    productReportCount?: number;
    sisErrorCode?: number;
    sisFault?: string;
    isCustomerOrderNumberRequired: 1 | 0;
    serviceHours?: ServiceTimes; // TODO: verify if this is the correct format
    technicalServiceHotline?: string; // TODO: verify if this is the correct format
    technicalGuideAvailable?: boolean; // TODO: verify if this is the correct format
}

// TODO: verify if this is the correct format
interface ServiceTimes {
    MonFriStart?: string; // utc time to be formatted with ux-date-time
    MonFriEnd?: string;
    SatStart?: string;
    SatEnd?: string;
}

export type CreateCaseResponse = CreateCaseResponseItem[];

// TODO: should we also prefill application data?
export interface PrefillData {
    notificationType?: NotificationTypeId | null;
    productData?: {
        assetId?: string | null;
        errorNumbers?: string[] | null;
    };
    softwareData?: {
        productNumber?: string | null;
        softwareModule?: string | null;
        softwareType?: string | null;
        isInstallationProblem?: boolean | null;
        isLicenseIssue?: boolean | null;
        softwareProblemClassification?: string | null;
    };
    callBackContact?: {
        salutation?: SalutationId | null;
        firstName?: string | null;
        lastName?: string | null;
        email?: string | null;
        phone?: string | null;
    };
}
